var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHideEyeBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Status=default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.3,
    d: "M12.239 11.0891C11.8323 11.9199 10.9873 12.4974 9.99984 12.4974C8.619 12.4974 7.49984 11.3782 7.49984 9.9974C7.49984 9.0099 8.07734 8.1649 8.90817 7.75823L6.22984 5.0799C3.07067 6.72156 1.6665 9.9974 1.6665 9.9974C1.6665 9.9974 4.1665 15.8307 9.99984 15.8307C12.1673 15.8307 13.8723 15.0241 15.1623 14.0124L12.239 11.0891ZM11.589 8.0824C11.7082 8.18073 11.8157 8.28906 11.9148 8.40823L16.3848 12.8782C17.7165 11.4324 18.3332 9.9974 18.3332 9.9974C18.3332 9.9974 15.8332 4.16406 9.99984 4.16406C9.2565 4.16406 8.569 4.26073 7.93234 4.42573L11.589 8.0824Z",
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.32715 3.50781L3.50564 2.32928L17.6728 16.4959L16.4943 17.6744L2.32715 3.50781Z",
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.1773 6.6899L13.3148 9.8274C13.2239 8.13323 11.8714 6.78073 10.1773 6.6899ZM14.5573 13.4257C13.3981 14.3107 11.8914 15.0049 9.99977 15.0049C5.5031 15.0049 3.19393 11.1807 2.59143 10.0074C3.0331 9.16156 4.40727 6.8874 6.85143 5.7199L5.60727 4.47656C2.4206 6.24823 0.980599 9.48906 0.900599 9.67656L0.759766 10.0049L0.900599 10.3332C1.01143 10.5924 3.68977 16.6716 9.99977 16.6716C12.4448 16.6716 14.3381 15.7566 15.7548 14.6232L14.5573 13.4257Z",
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.099 9.67427C18.9882 9.4151 16.3098 3.33594 9.99984 3.33594C8.99067 3.33594 8.084 3.50344 7.2565 3.76594L8.62817 5.1376C9.06234 5.0551 9.51567 5.0026 9.99984 5.0026C14.4965 5.0026 16.8057 8.82677 17.4082 10.0001C17.1632 10.4693 16.6273 11.3793 15.7865 12.2959L16.9748 13.4843C18.3748 11.9693 19.0448 10.4568 19.099 10.3309L19.2398 10.0026L19.099 9.67427ZM6.6665 10.0026C6.6665 11.8409 8.1615 13.3359 9.99984 13.3359C11.2107 13.3359 12.2623 12.6809 12.8457 11.7126L11.594 10.4609C11.394 11.1559 10.759 11.6693 9.99984 11.6693C9.08067 11.6693 8.33317 10.9218 8.33317 10.0026C8.33317 9.24344 8.8465 8.60844 9.5415 8.40844L8.28984 7.15677C7.3215 7.7401 6.6665 8.79177 6.6665 10.0026Z",
    fill: "#2894FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideEyeBlue);
export default __webpack_public_path__ + "static/media/hide-eye-blue.59892b7a1a702ff6970a89faacc0bbe6.svg";
export { ForwardRef as ReactComponent };